import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { AppBar, ButtonBase, Toolbar } from '@material-ui/core';
import { useTheme, withStyles } from '@material-ui/core/styles';

import { history } from 'evee-ui-common/services';

import useAuth from 'store/modules/auth/hooks/useAuth';

import LogoIcon from 'common/icons/Logo';
import useHideWebWidget from 'common/hooks/useHideWebWidget';

import HeaderNotification from 'widgets/layout/HeaderNotification';

import HamburgerButton from '../../utils/HamburgerMenu/HamburgerButton';
import MobileMenu from '../../Menu/MobileMenu';
import RewardsButton from '../../RewardsButton';
import SearchDialog from './SearchDialog';
import styles from './styles';

const MobileHeader = ({ classes }) => {
  const [menuOpened, setMenuOpened] = useState(false);
  const [pathName, setPathName] = useState();
  const theme = useTheme();
  const { signedIn } = useAuth();

  useHideWebWidget(menuOpened);

  useEffect(() => {
    setPathName(window.location.pathname);
  }, []);

  return (
    <>
      <AppBar
        position="sticky"
        className={classes.defaultAppBar}
        style={{
          boxShadow: menuOpened && 'none',
        }}
      >
        {pathName === '/' && <HeaderNotification />}

        <Toolbar className={classes.toolbar}>
          <ButtonBase style={{ marginRight: '16px' }} onClick={() => history.push('/')}>
            <LogoIcon htmlColor={theme.palette.primary.main} className={classes.logoIcon} />
          </ButtonBase>

          {!menuOpened && (
            <>
              <SearchDialog />
              <RewardsButton />
            </>
          )}

          <HamburgerButton
            color="primary"
            className={clsx(classes.menuButton, !signedIn && classes.loggedOutMenuButton)}
            onClick={() => {
              setMenuOpened((value) => !value);
            }}
          />
        </Toolbar>
      </AppBar>

      <MobileMenu
        menuOpened={menuOpened}
        onClick={() => setMenuOpened(false)}
        onClose={() => setMenuOpened(false)}
      />
    </>
  );
};

MobileHeader.propTypes = {
  classes: PropTypes.shape({
    toolbar: PropTypes.string.isRequired,
    defaultAppBar: PropTypes.string.isRequired,
    logoIcon: PropTypes.string.isRequired,
    menuButton: PropTypes.string.isRequired,
    loggedOutMenuButton: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(MobileHeader);
